import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import { useEffect } from 'react';
import TopMenuStore from '@src/business-components/top-menu/store';
import ComFooterStore from '@src/business-components/common-footer/store';
import kvPageStore from './components/kvPage/store';
import newPageStore from './components/newPage/store';
import mechaPageStore from './components/mechaPage/store';
import mechaUnitPageStore from './components/mechaUnitPage/store';
import featurePageStore from './components/featurePage/store';
import worldPageStore from './components/worldPage/store';
import contactWayPageStore from './components/contactWayPage/store';
import { observable } from 'mobx';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import vhCheck from 'vh-check';
import getRemScale from '@src/utils/get-rem-scale';
// import Toast from '@src/business-components/common-message';

class MainStore extends BaseStore {
  // 整屏轮播
  pageSwiperStore = new PageSwiperStore({
    swiperOptions: {
      // direction: 'horizontal',
      direction: 'vertical',
      effect: 'fade',
      // effect: 'slide',
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      mousewheel: true,
      observeSlideChildren: true,
      autoHeight: true,
      initialSlide: 0
    }
  });

  //  首页kv
  kvPageStore = new kvPageStore({ mainStore: this });
  //  新闻资讯
  newPageStore = new newPageStore({ mainStore: this });
  //  机兵介绍-普通
  mechaPageStore = new mechaPageStore({ mainStore: this });
  //  机兵介绍-特装
  mechaUnitPageStore = new mechaUnitPageStore({ mainStore: this });
  //  游戏特色
  featurePageStore = new featurePageStore({ mainStore: this });
  //  世界观
  worldPageStore = new worldPageStore({ mainStore: this });
  //  世界观
  contactWayPageStore = new contactWayPageStore({ mainStore: this });
  // 导航栏
  topMenuStore = new TopMenuStore({});
  // 底栏
  CommonFooterStore = new ComFooterStore({
    mainStore: this,
    scrollToTop: () => {
      this.pageSwiperStore.baseSwiperStore.onChange(0);
      this.CommonFooterStore.isActive = false;
    }
  });

  // 视频播放
  @observable bgmPlayState;

  // 从导航栏跳转到特定屏
  @observable topBarIndex;

  Lang() {
    if (getLanguageByPath() === 'zh-Hant') {
      return 'tc';
    } else {
      return getLanguageByPath();
    }
  }

  /**
   * 页面模块跟新切换-通知当前页面
   *  每个模块添加一个 isActive 变量 this.Page2Store,
   * @param current
   *  this.mechaUnitPageStore,
   */
  pageStore = [
    this.kvPageStore,
    this.newPageStore,
    this.mechaPageStore,
    this.mechaUnitPageStore,
    this.featurePageStore,
    this.worldPageStore,
    this.contactWayPageStore
  ];

  changePageVisible(current) {
    this.pageStore.map((item, index) => {
      // 滑动到版权页时，将倒数第二个模块（敌对目标）设置为激活状态
      if (current > this.pageStore.length - 1 && index === this.pageStore.length - 1) {
        item.isActive = true;
      } else {
        item.isActive = current === index;
      }
    });
  }

  /**
   * 跳转到特定屏
   * @param elementName
   */
  onScrollToElement(elementName) {
    this.topBarIndex = Number(elementName);
    this.pageSwiperStore.baseSwiperStore.onChange(this.topBarIndex);
  }

  /**
   * 传入变量名
   * @param parameter
   */
  removeHashParameter(parameter) {
    // 获取当前地址栏的哈希部分
    let hash = window.location.hash;
    // 构造正则表达式，匹配参数名为 parameter 的情况
    let regex = new RegExp('([&?]' + parameter + '=[^&]*$|&' + parameter + '=[^&]*)');
    // 从哈希中移除指定参数
    hash = hash.replace(regex, '');
    // 将更新后的哈希设置回地址栏
    window.location.hash = hash;
  }
  use() {
    super.use();
    let _this = this;

    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        const remScale = getRemScale();

        this.vhOffset = vhCheckResult?.offset || 0;
      } catch (e) {
        //console.log(e);
      }
    }, []);
    useEffect(
      () => {
        if (!this.kvPageStore.videoPlayState && this.bgmPlayState) {
          this.topMenuStore?.bgm.handleChange(true);
        } else {
          if (this.topMenuStore?.bgm.isPlaying) {
            this.bgmPlayState = true;
          }
          this.topMenuStore?.bgm.handleChange(false);
        }
      },
      [this.kvPageStore.videoPlayState]
    );
    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        // const remScale = getRemScale();

        this.vhOffset = vhCheckResult?.offset || 0;
        // alert(this.vhOffset);
      } catch (e) {
        //console.log(e);
      }
    }, []);

    useMount(async () => {
      // this.pageSwiperStore.baseSwiperStore.onChange(3);
      const backTopBtn1 = document.getElementById('footer_backTopBtnid1');
      const backTopBtn2 = document.getElementById('footer_backTopBtnid2');
      // alert(document.documentElement.style.fontSize + " " + window.innerWidth);
      if (backTopBtn1) {
        backTopBtn1.addEventListener('click', function () {
          _this.pageSwiperStore.baseSwiperStore.onChange(0);
        });
      }
      if (backTopBtn2) {
        backTopBtn2.addEventListener('click', function () {
          _this.pageSwiperStore.baseSwiperStore.onChange(0);
        });
      }
    });

    useEffect(
      () => {
        if (this.$routeMatch.query.module) {
          let module = this.$routeMatch.query.module;
          this.onScrollToElement(module);
          this.removeHashParameter('module');
        }
      },
      [this.$routeMatch.query.module]
    );

    useEffect(
      () => {
        this.changePageVisible(this.pageSwiperStore?.baseSwiperStore?.activeIndex);
      },
      [this.pageSwiperStore?.baseSwiperStore?.activeIndex]
    );
  }
}

export default MainStore;
